import React from "react";
import "./style.css";
import noavatar from "../../../assets/img/noavatar.png";

function CardPay({ data }) {
  console.log(data);
  return (
    <>
      {data?.map((item) => (
        <div key={item?.id}>
          <div className="d-flex justify-content-between align-items-center border_bottom_pay p-2">
            <div className="pay_product_img">
              <img
                src={
                  `${process.env.REACT_APP_URL_IMAGE + item?.product?.image}` || noavatar
                }
                alt="product"
                width="100%"
              />
            </div>

            <div className="pay_name_price">
              <p className="pay_name fs-20 t-capitalize">
                {item?.product?.name}
              </p>
              <p className="pay_price fs-20 pt-2 text-start">
                {" "}
                {(
                  (item?.product?.price * (100 - item?.product?.discount)) /
                  100
                ).toLocaleString("vi")}
                &#273;
              </p>
            </div>

            <div className="d-flex fs-20">
              x<span>{item?.quantity}</span>
            </div>
          </div>
        </div>
      ))}
    </>
  );
}

export default CardPay;
